// extracted by mini-css-extract-plugin
export var productImage = "_103-0";